// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"780fdbc2","450":"f3a0279a"}[chunkId] + ".chunk.css";
};